import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const HomePage = () => {
  const { isAuthenticated, isAdmin } = useAuth();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          my: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          minHeight: '60vh',
        }}
      >
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to the Feedback Platform
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph>
          Streamline your feedback process. Admins can upload content, and users can provide valuable insights.
        </Typography>
        <Box sx={{ mt: 4 }}>
          {isAuthenticated ? (
            isAdmin ? (
              <Button component={Link} to="/dashboard" variant="contained" size="large">
                Go to Your Dashboard
              </Button>
            ) : (
              <Typography variant="body1">You are logged in as a user. Awaiting a review link.</Typography>
            )
          ) : (
            <Button component={Link} to="/login" variant="contained" size="large">
              Get Started
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default HomePage;